<template>
  <div class="auth-page">
    <div class="back-to-home" @click="back()">
      <svg width="36" height="36" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M15 18L9 12L15 6" stroke="#dcc49e" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>

    <div class="lang-switch" @click.stop="toggleLangMenu">
      <span class="lang-current">{{ currentLangLabel }}</span>
      <div v-if="langMenuVisible" class="lang-menu">
        <button
          v-for="item in langOptions"
          :key="item.code"
          type="button"
          class="lang-option"
          :class="{ active: lang === item.code }"
          @click.stop="changeLang(item.code)"
        >
          {{ item.label }}
        </button>
      </div>
    </div>

    <div class="login-background">
      <div class="background-image"></div>
    </div>

    <div class="login-content">
      <div class="logo-wrap">
        <img :src="assets.logo" alt="brand logo" class="brand-logo">
      </div>

      <form class="login-form" @submit.prevent="doLogin()">
        <div class="field-box">
          <label class="field-inner">
            <span class="field-icon">
              <svg width="36" height="36" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M20 21V19C20 16.7909 18.2091 15 16 15H8C5.79086 15 4 16.7909 4 19V21" stroke="#f3c7a2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <circle cx="12" cy="7" r="4" stroke="#f3c7a2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
            <input
              v-model.trim="username"
              type="text"
              name="account"
              :placeholder="$t('auth.username')"
              autocomplete="username"
            >
          </label>
        </div>

        <div class="field-box">
          <label class="field-inner">
            <span class="field-icon">
              <svg width="36" height="36" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2" stroke="#f3c7a2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11" stroke="#f3c7a2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
            <input
              v-model="password"
              type="password"
              name="password"
              :placeholder="$t('auth.password')"
              autocomplete="current-password"
            >
          </label>
        </div>

        <button type="submit" class="gradient-login-btn">{{ $t('auth.sign_in') }}</button>
      </form>

      <div class="auth-link-row">
        <button class="auth-link" @click="toRegister()">{{ $t('auth.sign_up') }}</button>
      </div>
    </div>

    <button class="support-btn" @click="openSupport">
      <img src="/img/mine/kefu.png" alt="support">
    </button>

  </div>
</template>

<script>
const ASSETS = {
  logo: '/img/login/sincere-logo.png',
  background: '/img/login/target_login_bg.jpg'
};

export default {
  data() {
    return {
      assets: ASSETS,
      username: '',
      password: '',
      lang: localStorage.getItem('lang') || 'en',
      langMenuVisible: false,
      langOptions: [
        { code: 'en', label: 'English' },
        { code: 'es', label: 'Español' },
        { code: 'it', label: 'Italiano' },
        { code: 'pt', label: 'Português' }
      ]
    };
  },
  computed: {
    currentLangLabel() {
      const found = this.langOptions.find((item) => item.code === this.lang);
      return found ? found.label : 'English';
    }
  },
  created() {
    this.syncLang(this.lang, false);
    if (localStorage.getItem('token')) {
      return window.history.back();
    }
    this.ensureBaseInfo();
  },
  mounted() {
    document.addEventListener('click', this.closeLangMenu);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeLangMenu);
  },
  methods: {
    closeLangMenu() {
      this.langMenuVisible = false;
    },
    toggleLangMenu() {
      this.langMenuVisible = !this.langMenuVisible;
    },
    syncLang(lang, reloadPage = false) {
      this.lang = lang;
      this.$i18n.locale = lang;
      localStorage.setItem('lang', lang);
      this.$http({
        method: 'get',
        url: 'replaceLang',
        data: { lang }
      });
      if (reloadPage) {
        window.location.reload();
      }
    },
    changeLang(lang) {
      this.langMenuVisible = false;
      if (lang === this.lang) {
        return;
      }
      this.syncLang(lang, true);
    },
    async ensureBaseInfo() {
      const current = this.$store.getters.getBaseInfo || {};
      if (current && Object.keys(current).length) {
        return current;
      }

      try {
        const res = await this.$http({
          method: 'get',
          url: 'base_info'
        });
        if (res && res.data) {
          this.$store.commit('setBaseInfoValue', res.data);
          return res.data;
        }
      } catch (error) {
        return current;
      }

      return current;
    },
    normalizeLoginMessage(message) {
      const raw = String(message || '').trim();
      if (!raw) {
        return this.$t('auth.login_failed');
      }

      if (
        raw.includes('ユーザーが存在しません') ||
        raw.includes('用户不存在') ||
        raw.includes('User does not exist')
      ) {
        return this.$t('auth.user_not_exist');
      }

      if (
        raw.includes('密码错误') ||
        raw.includes('Incorrect password') ||
        raw.includes('パスワード')
      ) {
        return this.$t('auth.incorrect_password');
      }

      if (
        raw.includes('账号已被禁用') ||
        raw.includes('账号被禁用') ||
        raw.includes('账户被禁用') ||
        raw.includes('zhbjy')
      ) {
        return this.$t('auth.account_disabled');
      }

      return raw;
    },
    back() {
      return window.history.back();
    },
    toRegister() {
      this.$router.push('/Register');
    },
    async openSupport() {
      const service = await this.ensureBaseInfo();
      if (service.iskefu == 1 && service.kefu) {
        window.location.href = service.kefu;
        return;
      }
      this.$router.push('/ServiceOnline');
    },
    doLogin() {
      const username = String(this.username || '').trim();
      const password = String(this.password || '').trim();

      if (!username) {
        this.$toast(this.$t('auth.username_required'));
        return;
      }
      if (!password) {
        this.$toast(this.$t('auth.password_required'));
        return;
      }
      this.$http({
        url: 'member_login',
        method: 'post',
        data: {
          username,
          password
        }
      }).then((res) => {
        if (res.code === 200) {
          this.$toast.success(this.$t('auth.login_success'));
          sessionStorage.removeItem(`login_intro_shown_${res.data.id}`);
          sessionStorage.setItem('login_intro_pending', '1');
          localStorage.setItem('token', res.data.id);
          if (this.$root && typeof this.$root.refreshLoginIntroConfig === 'function') {
            this.$root.refreshLoginIntroConfig();
          }
          this.$router.push('/Mine');
        } else {
          this.$toast(this.normalizeLoginMessage(res.msg));
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.auth-page {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  background: #d9d4d9;
}

.back-to-home {
  position: absolute;
  left: 28px;
  top: 28px;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: rgba(189, 183, 190, 0.48);
  backdrop-filter: blur(2px);
}

.lang-switch {
  position: absolute;
  right: 28px;
  top: 28px;
  z-index: 6;
  min-width: 168px;
}

.lang-current {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 72px;
  padding: 0 28px;
  border-radius: 36px;
  background: rgba(189, 183, 190, 0.62);
  color: #5d4a52;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.2;
  backdrop-filter: blur(2px);
  cursor: pointer;
}

.lang-menu {
  position: absolute;
  right: 0;
  top: 84px;
  min-width: 220px;
  padding: 12px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 10px 24px rgba(93, 74, 82, 0.18);
}

.lang-option {
  display: block;
  width: 100%;
  border: 0;
  background: transparent;
  color: #5d4a52;
  font-size: 28px;
  font-weight: 600;
  text-align: left;
  padding: 22px 18px;
  border-radius: 14px;
  cursor: pointer;
}

.lang-option.active,
.lang-option:hover {
  background: rgba(243, 199, 162, 0.35);
}

.login-background,
.background-image {
  position: fixed;
  top: 0;
  height: 100%;
}

.login-background {
  left: calc(50% - min(50%, 375px));
  width: min(100%, 750px);
  overflow: hidden;
  z-index: 0;
}

.background-image {
  inset: 0;
  width: 100%;
  height: 100%;
  background: url('/img/login/target_login_bg.jpg') no-repeat 0 0;
  background-size: auto 100%;
  animation: auth-bg-pan 70s linear infinite;
}

.login-content {
  position: relative;
  z-index: 3;
  width: 100%;
  min-height: 100vh;
  padding: 140px 36px 72px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.logo-wrap {
  display: flex;
  justify-content: center;
  margin: 80px 0 72px;
}

.brand-logo {
  width: 220px;
  height: 220px;
  object-fit: contain;
  filter: drop-shadow(0 12px 24px rgba(108, 74, 86, 0.28));
}

.login-form {
  margin-top: 0;
}

.field-box {
  margin-bottom: 28px;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 10px 24px rgba(143, 133, 146, 0.16);
}

.field-inner {
  display: flex;
  align-items: center;
  min-height: 96px;
  padding: 0 28px;
  background: rgba(232, 237, 247, 0.92);
  border: 1px solid rgba(214, 206, 214, 0.8);
  box-sizing: border-box;
}

.field-icon {
  display: inline-flex;
  width: 40px;
  height: 40px;
  margin-right: 20px;
  align-items: center;
  justify-content: center;
  flex: none;
}

.field-icon svg {
  width: 40px;
  height: 40px;
}

.field-inner input {
  width: 100%;
  border: none;
  background: transparent;
  color: #7d6a53;
  font-size: 30px;
  font-weight: 600;
  line-height: 1.3;
  outline: none;
}

.field-inner input::placeholder {
  color: #c7b299;
  font-size: 28px;
}

.gradient-login-btn {
  width: 100%;
  height: 96px;
  margin-top: 28px;
  border: none;
  border-radius: 999px;
  background: linear-gradient(180deg, #f7dfc5 0%, #eabf93 100%);
  color: #5e3933;
  font-size: 34px;
  font-weight: 700;
  box-shadow: 0 14px 30px rgba(181, 141, 113, 0.24);
}

.auth-link-row {
  margin-top: 28px;
  text-align: left;
}

.auth-link {
  padding: 0;
  border: none;
  background: transparent;
  color: rgba(222, 188, 148, 0.95);
  font-size: 28px;
  font-weight: 700;
  text-shadow: 0 1px 3px rgba(110, 92, 100, 0.2);
}

.support-btn {
  position: fixed;
  right: 28px;
  bottom: 180px;
  z-index: 6;
  width: 96px;
  height: 96px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  box-shadow: 0 14px 28px rgba(225, 48, 66, 0.22);
}

.support-btn img {
  width: 100%;
  height: 100%;
  display: block;
}

@keyframes auth-bg-pan {
  0%,
  100% {
    background-position-x: 0;
  }

  50% {
    background-position-x: 100%;
  }
}

@media (min-width: 768px) {
  .auth-page {
    max-width: 750px;
    margin: 0 auto;
  }

  .login-content {
    max-width: 680px;
    margin: 0 auto;
  }
}
</style>
